import { normalizeName, similarityScore } from "./pgNameSimilarity";

/** Default threshold matching {@link useBondPrincipalNameSuggestion} dialog. */
export const PRINCIPAL_PG_NAME_THRESHOLD = 0.92;

/**
 * Best PG option by label similarity vs typed name (`normalizeName`).
 * @returns {{ best: object|null, bestScore: number }}
 */
export function findBestPgNameMatch(rawName, professionalGuardians) {
  const clean = normalizeName(rawName);
  if (!clean || clean.length < 4) {
    return { best: null, bestScore: 0, clean };
  }
  let best = null;
  let bestScore = 0;
  for (const pg of professionalGuardians || []) {
    const score = similarityScore(clean, pg.label);
    if (score > bestScore) {
      bestScore = score;
      best = pg;
    }
  }
  return { best, bestScore, clean };
}
